export default __webpack_public_path__ + "static/media/tire-finder-art.fd8c1a8d.png";